import React from 'react';
import styles from "./styles.module.scss";
import Alert from "../Icons/Common/Alert";
import PropTypes from "prop-types";

const Index = ({message, type, schema, position, children}) => {
  return (
    <div className={styles["error-wrapper"]}>
      <div>
        <Alert/>
      </div>
      <p className={styles["error-text"]}>{message}</p>
    </div>
  );
};

Index.defaultprops = {
  message: "",
  type: "default",
  schema: "error",
  position: "top"
}

Index.proptypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(["default, custom"]),
  schema: PropTypes.oneOf(["error", "warning"]),
  position: PropTypes.oneOf(["top", "bottom"])
}

export default Index;